import src from "IMAGE";
export default { src, width: 1000, height: 420, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAQ0lEQVR42hXKsQpAUBQA0LtK8gUMMkhWs1mZ/IHdIhal/Po7bzjbiYgY2dk4GaioKYmei4Ofl5uPJ4eCmYmWjoaVJQErcAYkeFYBzQAAAABJRU5ErkJggg=="};
